/*
  A component for rendering the upload document panel on the right side when upload option has been selected from the sidebar
*/

import React from 'react';
import { Tabs } from 'antd';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import NavAndSideFrame from '../../components/NavAndSideFrame';
import DocumentUploadList from '../../components/item/DocumentUploadList'

// const debug = require('debug')('app:pages/admin/ItemConfig');

const selectedKey = "upload_doc";       // To highlight/select the object clicked for viewing on the right pan
const openKey = "upload";               // To open the sidebar tab which has been selected
const { TabPane } = Tabs;

const UploadDocument = (props) => {
  const { t } = useTranslation()       // for translating from English to Chinese and Vice-versa using json files
  const disableEdit = useSelector(
    (state) => !_.includes(state.app.adminUIPermissions, 'ui_all') && !_.includes(state.app.adminUIPermissions, 'ui_upload_w')
  );

  return (
    // NavAndSideFrame is there to render the sidebar, selectedKey: The options that needs to be highlated, openKey: which toggle bar should be open
    <NavAndSideFrame {...props} title={t("upload_doc")} selectedKey={selectedKey} openKey={openKey}>
      {/* As upload option only have one tab option, then we jyst use one tab and give it one key for referenceing */}
      <Tabs defaultActiveKey={1}>
        <TabPane tab={t('upload')} key="1">
          {/* DocumentUploadList will render and produce the right hand side of the section */}
          <DocumentUploadList disableEdit={disableEdit} />
        </TabPane>
      </Tabs>
    </NavAndSideFrame>
  )
}

export default UploadDocument;